<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addCustom"/>
      </div>
      <input-select selectTitle="缴费方式" :selectKey="'payType'" :selectData="payTypeList" @search="search"/>
    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" :deleteTipInfo="'是否确认删除该金额配置'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" @deleteLine="deleteLine" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/ParkingService'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nSuccess} from '../../../utils/notice'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'amount-allocation',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧停车',
          name: 'amount-allocation'
        }, {
          value: '金额配置'
        }],
        addCustom: 'amount-add',
        payTypeList: [{
          key: '',
          label: '全部'
        }, {
          key: '1',
          label: '月缴'
        }, {
          key: '2',
          label: '季缴'
        }, {
          key: '3',
          label: '半年缴'
        }, {
          key: '4',
          label: '年缴'
        }],
        tableHead: [{
          prop: 'payTypeText',
          label: '缴费方式'
        }, {
          prop: 'payAmount',
          label: '金额(元)'
        }, {
          prop: 'memo',
          label: '备注'
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        requestData: {
          searchKey: '',
          payType: ''
        },
        operationArr: ['modify', 'delete']
      }
    },
    created () {
      // this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    methods: {
      getPage () {
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        this.$axios.post(api.getParkingBasicConfigPage, reqData)
          .then(res => {
            let data = res.data.data.list
            data.map(v => {
              if (v.payType === '1') {
                v.payTypeText = '月缴'
              } else if (v.payType === '2') {
                v.payTypeText = '季缴'
              } else if (v.payType === '3') {
                v.payTypeText = '半年缴'
              } else if (v.payType === '4') {
                v.payTypeText = '年缴'
              }
            })
            this.total = res.data.data.total
            this.tableData = data
          })
          .catch(errorHandler('获取金额信息失败'))
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      goToModifyPage (code) {
        this.$router.push({
          path: `/park_server/amount_modify/${code}`
        })
      },
      deleteLine (code) {
        this.$axios.post(api.deleteParkingBasicConfigByCodes, code)
          .then(res => {
            if (res.data.retCode == 1) {
              nSuccess('删除成功')
              this.getPage()
            }
          })
          .catch(errorHandler('删除金额配置失败'))
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/AmountAllocation/AmountAllocation.vue